import { MiniCASProjectList } from "@/components/Projects/Table/ProjectList";
import { SectionDiv } from "./Components/SectionDiv";

export function CAProjectListContainer() {
    return (
        <SectionDiv className="overflow-y-auto">
            <h3 className="">Construction Admin Projects:</h3>
            <MiniCASProjectList />
        </SectionDiv>
    )
}
